module.exports = __webpack_public_path__ + "vimeo.png?fdcbd3b6205bb2eb8cbe48441f728d2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/vimeo.png
// module id = 131
// module chunks = 0